import { render, staticRenderFns } from "./InfosAffaireBottom.vue?vue&type=template&id=2c1d1f10&scoped=true&"
import script from "./InfosAffaireBottom.vue?vue&type=script&lang=js&"
export * from "./InfosAffaireBottom.vue?vue&type=script&lang=js&"
import style0 from "./InfosAffaireBottom.vue?vue&type=style&index=0&id=2c1d1f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d1f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1d1f10')) {
      api.createRecord('2c1d1f10', component.options)
    } else {
      api.reload('2c1d1f10', component.options)
    }
    module.hot.accept("./InfosAffaireBottom.vue?vue&type=template&id=2c1d1f10&scoped=true&", function () {
      api.rerender('2c1d1f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/affaire/components/InfosAffaireBottom.vue"
export default component.exports